export const MapSearchRadius = 10;